import { supabase } from './supabaseClient';

export const fetchFacilities = async () => {
    const { data, error } = await supabase
        .from('facilities')
        .select('*')
        .order('created_at', { ascending: true });
    
    if (error) {
        console.error('Error fetching facilities:', error);
        return [];
    }
    // We map 'description' from DB to 'desc' for the frontend components
    return data.map(item => ({
        ...item,
        desc: item.description
    }));
};

export const createFacility = async (facilityData) => {
    const { data, error } = await supabase
        .from('facilities')
        .insert([{
            title: facilityData.title,
            description: facilityData.desc // map 'desc' to 'description'
        }])
        .select();
    
    if (error) {
        console.error('Error creating facility:', error);
        throw error;
    }
    return { ...data[0], desc: data[0].description };
};

export const updateFacility = async (id, facilityData) => {
    const { data, error } = await supabase
        .from('facilities')
        .update({
            title: facilityData.title,
            description: facilityData.desc // map 'desc' to 'description'
        })
        .eq('id', id)
        .select();
    
    if (error) {
        console.error('Error updating facility:', error);
        throw error;
    }
    return { ...data[0], desc: data[0].description };
};

export const deleteFacility = async (id) => {
    const { error } = await supabase
        .from('facilities')
        .delete()
        .eq('id', id);
    
    if (error) {
        console.error('Error deleting facility:', error);
        throw error;
    }
};
